import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { GroupUsersAddComponent } from '../shared/dialogs/groups-users-add/groups-users-add.component';
import { GroupUsersEditComponent } from '../shared/dialogs/groups-users-edit/groups-users-edit.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-groups-usrs',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsUsersComponent implements OnInit {

  private idRoleAdmin = environment.role_admin_id;
  userList = new Array<any>();
  isLoading = true;  
  roles = [{id : 1, nombre:"Super Admin"},{id : 2, nombre:"Buho"},{id : 3, nombre:"Cliente"}]

  displayedColumns: string[] = ['id', 'tipo', 'nombre', 'permisos', 'created_at', 'actions'];
  dataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private userS: UsersService,
    private matDialog: MatDialog,
    private _titleService: Title,
  ) {
    this._titleService.setTitle("Buho Nest - Usuarios");
    this.getUsersList();
  }

  ngOnInit(): void {
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.userS.hasPermissions(key, buho, client);
  }

  getUsersList() {
    this.userS.getGroupsList(0).subscribe(
      (result : any) => {
        this.userList = result.data;
        this.dataSource = new MatTableDataSource(this.userList);        
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      (err : any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getRol(rol_id: any){
    return this.roles.find(x => x.id == rol_id)?.nombre ?? "Desconocido";
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  deleteUser(id:any): void {
    if (this.userS.getUser().id_rol != this.idRoleAdmin) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: '¡No tienes permitido realizar esta acción!',        
      })
    }
    else {
      Swal.fire({
        title: '¿Está seguro que desea eliminar el registro?',
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: 'info',
            title: 'Eliminando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          this.userS.deleteGroup(id).subscribe(
            (result:any) => {
              if (result.message == "Success")                
              Swal.fire({
                icon: 'success',
                title: 'Eliminado',
                text: 'Grupo eliminado de manera correcta!'
              }).then(() => {
                this.getUsersList();
              });
            },
            
            (err:any) => {
                if(err.error.message.indexOf("group has users assigned") > -1)
                {
                  Swal.fire({
                    icon: 'error',
                    title: 'Grupo con usuarios asignados',
                    text: 'No se puede eliminar el grupo porque tiene usuarios asignados con únicamente este grupo.'
                  });
                }
                else {
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar',
                text: 'Ocurrió un error al eliminar el registro, por favor vuelva a intentarlo.'
              });
              }

            }
          );
        }
      });
    }
  }

  isAdmin() {
    return (this.userS.getUser().id_rol == this.idRoleAdmin);
  }

  activateUser(id: number, active: number, fullname: string, idServ: number) {
    var action = active == 1 ? "desactivado" : "activado";
    Swal.fire({
      icon: 'info',
      title: 'Espere...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.userS.changeStatusUser(id, active == 1 ? 0 : 1, idServ).subscribe(
      (result:any) => {
        if (result.message == "Success")
          Swal.fire({
            icon: 'success',
            title: 'Actualizado',
            text: 'Se ha ' + action + ' a ' + fullname + ' de manera correcta!'
          }).then(() => {
            this.getUsersList();
          });
      },
      (err:any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
        });
      }
    );
  }

  openDialogUsersCreate() {
    this.matDialog.open(GroupUsersAddComponent, {panelClass: 'dialogs-main'}).afterClosed().subscribe(
      resp => {        
          this.isLoading = true;
          this.getUsersList();        
      }
    );
  }

  openDialogUsersEdit(user: any) {
    this.matDialog.open(GroupUsersEditComponent, {
      panelClass: 'dialogs-main',
      data: {
        userSel: user
      }
    }).afterClosed().subscribe(
      resp => {        
          this.isLoading = true;
          this.getUsersList();        
      }
    );
  }

  getCompanyName(companyList : any[]){
    var retCompany = "-";
    if(companyList.length > 0){
      retCompany = companyList[0].company_name;
    }
    return retCompany;
  }

}
